import { AuthService } from './../../shared/models/auth.service';
import { Injectable } from '@angular/core';
import { Http, Response, Headers, RequestOptions } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { WeGoConfig, IAPIResponse, DataListModel } from '../../shared/config';
import { ErrorLogModel, ErrorLogFilterModel } from './errorlog.model';
import { JQueryHelperService } from '../../shared/models/jquery-helper.service';

@Injectable()
export class ErrorLogService {
  private JQueryHelper: JQueryHelperService = new JQueryHelperService();
  constructor(private authService: AuthService, private http: Http) {}

  public GetErrorLogList(
    searchModel :ErrorLogFilterModel,input?: DataListModel,
  ): Observable<IAPIResponse> {
    let getErrorLogUrl = WeGoConfig.API_GET_ERRORLOG_LIST;
    let queryString = this.authService.HandleAPIListInput(input);
    let queryStringErrorLog = this.JQueryHelper.Param(searchModel);

    getErrorLogUrl = getErrorLogUrl + '?' + queryString + '&' + decodeURIComponent(queryStringErrorLog);

    let headers = this.authService.GetHeader();
    let options = new RequestOptions({ headers: headers });
    return this.http
      .get(getErrorLogUrl, options)
      .map(this.authService.HandleAPIResponse)
      .catch(this.authService.HandleAPIError);
  }

  public ExportErrorLog(
    searchModel :ErrorLogFilterModel,
    input?: DataListModel
  ): any {
    input.currentPage = 0;
    let exportrrorLogUrl = WeGoConfig.API_GET_EXPORT_ERRORLOG;
    let queryString = this.authService.HandleAPIListInput(input);
    let queryStringErrorLog = this.JQueryHelper.Param(searchModel);

    exportrrorLogUrl = exportrrorLogUrl + '?' + queryString +  decodeURIComponent(queryStringErrorLog);

    let headers = this.authService.GetHeader('text/csv');
    let options = new RequestOptions({ headers: headers });
    return this.http.get(exportrrorLogUrl, options);
  }

  public GetErrorLogTypeDropdownList(input?: DataListModel): Observable<IAPIResponse> {
    let getErrorLogTypeDropdownUrl = WeGoConfig.API_GET_DROPDOWN_ERRORLOGTYPE_LIST;
    let headers = this.authService.GetHeader();
    let options = new RequestOptions({ headers: headers });
    return this.http.get(getErrorLogTypeDropdownUrl, options)
      .map(this.authService.HandleAPIResponse)
      .catch(this.authService.HandleAPIError);
  }

  public GetErrorLogComponentDropDownList(input?: DataListModel): Observable<IAPIResponse> {
    let getErrorLogTypeDropdownUrl = WeGoConfig.API_GET_DROPDOWN_ERRORLOGCOMPONENT_LIST;
    let headers = this.authService.GetHeader();
    let options = new RequestOptions({ headers: headers });
    return this.http.get(getErrorLogTypeDropdownUrl, options)
      .map(this.authService.HandleAPIResponse)
      .catch(this.authService.HandleAPIError);
  }  
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/errorlog/models/errorlog.service.ts